export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  ShouldPassSelectedShippingOptionToExpressCheckout: 'specs.stores.ShouldPassSelectedShippingOptionToExpressCheckout',
  ShouldAddSpecificItemDiscountsForCashierValidation: 'specs.stores.ShouldAddSpecificItemDiscountsForCashierValidation'
};
//# sourceMappingURL=SPECS.js.map